import IndicesMonetariosVisualizacaoModal from 'app/main/configuracao/components/tabs/ParametroTab/modal/IndicesMonetariosVisualizacaoModal';
import {
  EmpresaCadastroModal,
  EmpresaModais,
  EmpresaVisualizacaoModal,
  ModalAlteracaoPlanoComercial,
} from 'app/main/empresa/modal';
import ModalSelecionarEmpresa from 'app/main/empresa/modal/selecionar-empresa/ModalSelecionarEmpresa';
import { FaturamentoErrosModal, FaturamentoModais, FaturamentoModal } from 'app/main/faturamento/modal';
import { FechamentoPeriodo } from 'app/main/fechamentoperiodo';
import { AlterarSenhaModal, LoginModais } from 'app/main/login/modal';
import { TermoUsoModal } from 'app/main/publico/primeiroacesso';
import { CadastroUsuarioModal, VisualizarUsuarioModal } from 'app/main/usuario/components';
import { ModalClienteBloqueado, ModalDesbloqueioSolicitado, ModalPeriodoTrial } from 'app/main/validacaocliente';
import { ValidacaoClienteModais } from 'app/main/validacaocliente/ValidacaoClienteModais';
import { usuarioApi } from 'app/services/api/usuarioApi';
import TracksaleWidget from 'app/TracksaleWidget';
import React, { useContext, useEffect } from 'react';
import { GlobalContext } from './GlobalContext';

const GlobalComponents = () => {
  const [modal] = useContext(GlobalContext).modal;
  const [indicesMonetariosModal] = useContext(GlobalContext).indicesMonetariosModal;
  const [modalEmpresa] = useContext(GlobalContext).modalEmpresa;
  const [modalPendenciasFaturamento] = useContext(GlobalContext).modalPendenciasFaturamento;
  const [modalErrosFaturamento] = useContext(GlobalContext).modalErrosFaturamento;
  const [termoUsoModal] = useContext(GlobalContext).termoUsoModal;
  const [modalValidacaoCliente, setModalValidacaoCliente] = useContext(GlobalContext).modalValidacaoCliente;
  const [, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;

  const validarCliente = async () => {
    try {
      await usuarioApi.validarAcessoCliente();
    } catch (error) {
      if (error?.response?.data?.errorKey?.includes('error.cliente.periodo-trial-expirado')) {
        setModalValidacaoCliente(ValidacaoClienteModais.modalPeriodoTrial);
      } else if (error?.response?.data?.errorKey?.includes('error.cliente.acesso-bloqueado')) {
        setModalValidacaoCliente(ValidacaoClienteModais.modalClienteBloqueado);
      }
    }
  };

  const buscarAtalhos = async () => {
    try {
      const res = await usuarioApi.buscarAtalhos();
      if (res.data) {
        localStorage.setItem('BuscarAtalhos', JSON.stringify(res.data));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const buscarTour = async () => {
    try {
      const resp = await usuarioApi.buscarTour();
      setFuncionalidadesTour(resp.data);
    } catch (error) {
      console.log(error);
    }
  };

  const empresaContextoArmazenada = localStorage.getItem('EC');
  useEffect(() => {
    if (localStorage.getItem('EC')) {
      validarCliente();
      buscarAtalhos();
      buscarTour();
    }
    // A função é recriada a cada render; incluí-la reexecutaria a busca em loop.
    // O efeito depende apenas do gatilho listado.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresaContextoArmazenada]);

  return (
    <>
      <TracksaleWidget />
      {modal === 'visualizacaoUsuario' && <VisualizarUsuarioModal />}
      {modal === 'cadastroUsuario' && <CadastroUsuarioModal />}
      {modal === 'fechamentoPeriodo' && <FechamentoPeriodo />}

      {indicesMonetariosModal === 'visualizarIndices' && <IndicesMonetariosVisualizacaoModal />}
      {modalEmpresa === EmpresaModais.visualizarEmpresa && <EmpresaVisualizacaoModal />}
      {modalEmpresa === EmpresaModais.cadastrarEmpresa && <EmpresaCadastroModal />}

      {/* {modalRelatorios !== '' && modalRelatorios !== undefined && modalRelatorios === RelatoriosModais.relatorioDre && (
        <ModalRelatorioDre />
      )} */}

      {/* {modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioFluxoCaixa && <ModalRelatorioFluxoCaixa />} */}

      {/* {modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioBalancente && <ModalRelatorioBalancete />} */}

      {/* {modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioVendaDetalhada && <ModalRelatorioVendaDetalhada />} */}

      {/* {modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioCentroCusto && <ModalRelatorioCentroCusto />} */}

      {/* {modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioCliente && <ModalRelatorioCliente />} */}

      {/* {modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioDespesa && <ModalRelatorioDespesa />} */}

      {/* {modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioReceita && <ModalRelatorioReceita />} */}

      {/* {modalRelatorios !== '' &&
         modalRelatorios !== undefined &&
         modalRelatorios === RelatoriosModais.relatorioContratosVigentes && <ModalRelatorioContratosVigentes />} */}

      {/*modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioReceitaCliente && <ModalRelatorioReceitaCliente />*/}

      {/*modalRelatorios !== '' &&
        modalRelatorios !== undefined &&
        modalRelatorios === RelatoriosModais.relatorioDespesaFornecedor && <ModalRelatorioDespesaFornecedor />*/}

      {modalPendenciasFaturamento === FaturamentoModais.modalPendenciasFaturamento && <FaturamentoModal />}
      {modalErrosFaturamento === 'modalErrosFaturamento' && <FaturamentoErrosModal />}

      {modal === EmpresaModais.modalSelecionarEmpresa && <ModalSelecionarEmpresa />}

      {modal === LoginModais.alterarSenha && <AlterarSenhaModal />}

      {termoUsoModal === 'termoUsoModal' && <TermoUsoModal />}
      {modal === EmpresaModais.alteracaoPlanoComercial && <ModalAlteracaoPlanoComercial />}

      {modalValidacaoCliente === ValidacaoClienteModais.modalPeriodoTrial && <ModalPeriodoTrial />}
      {modalValidacaoCliente === ValidacaoClienteModais.modalClienteBloqueado && <ModalClienteBloqueado />}
      {modalValidacaoCliente === ValidacaoClienteModais.modalDesbloqueioSolicitado && <ModalDesbloqueioSolicitado />}
    </>
  );
};

export default GlobalComponents;
